import { render, staticRenderFns } from "./GovBrAuth.vue?vue&type=template&id=9bfaf1d2&scoped=true&lang=pug"
import script from "./GovBrAuth.vue?vue&type=script&lang=js"
export * from "./GovBrAuth.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9bfaf1d2",
  null
  
)

export default component.exports